import { getStoredToken } from "./tokenStore";

// In Office Desktop, MSAL's acquireTokenSilent uses hidden iframes that
// don't work reliably in the isolated WebView2 taskpane context. We use
// the token acquired directly in the auth dialog instead.

export async function getCrmToken(): Promise<string> {
  const token = getStoredToken();
  if (!token) {
    throw new Error("No valid token. Please sign in again.");
  }
  return token;
}

// Graph token not supported in this flow — placeholder for future use
export async function getGraphToken(): Promise<string> {
  throw new Error("Graph token not available in current auth flow.");
}
